import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loading from '../components/Loading';
import ProtectedRoute from '../components/ProtectedRoute';
import ScrollToTop from './scrollToTop';
const Login = React.lazy(() => import('../pages/Login'));
const Structure = React.lazy(() => import('../pages/Structure'));
const ResetPassword = React.lazy(() => import('../pages/ResetPassword'));
const TwoFactorLogin = React.lazy(() => import('../pages/TwoFactorLogin'));
const NotFound = React.lazy(() => import('../pages/NotFound'));
const Terms = React.lazy(() => import('../pages/Terms'));
const AcceptInvite = React.lazy(() => import('../pages/AcceptInvite'));
const SpkForm = React.lazy(() => import('../pages/SpkForm'));
const ApiDocs = React.lazy(() => import('../pages/ApiDocs'));

interface AppState {
  loading: boolean;
  actions: {
    unpackToken: (_data: any, _firstInit?: boolean) => Promise<void>;
  };
}

interface RoutesProps {
  appState: AppState;
}

const Routes: React.FC<RoutesProps> = ({ appState }) => {
  return (
    <Suspense fallback={<Loading />}>
      <ScrollToTop />
      <Switch>
        <Route path="/" exact render={() => <Login config={appState} />} />
        <Route path="/redefinir-senha" render={() => <ResetPassword />} />
        <Route path="/convite" render={() => <AcceptInvite />} />
        <Route path="/cadastro-spk" render={() => <SpkForm />} />
        <Route path="/termos" component={Terms} />
        <Route
          path="/verificacao-2fa"
          render={() => <TwoFactorLogin config={appState} />}
        />
        <Route
          path="/api-docs"
          render={() => (
            <ProtectedRoute>
              <ApiDocs />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/dashboard/:subpage?/:interpage?"
          render={() => (
            <ProtectedRoute>
              <Structure />
            </ProtectedRoute>
          )}
        />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
};

export default Routes;
